import { render, staticRenderFns } from "./ErrorOverlay.vue?vue&type=template&id=4efac822&scoped=true&"
import script from "./ErrorOverlay.vue?vue&type=script&lang=js&"
export * from "./ErrorOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ErrorOverlay.vue?vue&type=style&index=0&id=4efac822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efac822",
  null
  
)

export default component.exports